/* Actions */
const SET_UPSELL_PLAN_BENEFITS = 'orderPage/SET_UPSELL_PLAN_BENEFITS';
const SET_PLAN_DETAILS = 'orderPage/SET_PLAN_DETAILS';

export const contextActions = {
  setPlanDetails(payload) {
    return { type: SET_PLAN_DETAILS, payload };
  },
  setUpsellPlanBenefits(payload) {
    return { type: SET_UPSELL_PLAN_BENEFITS, payload };
  },
};

/**
 * All of the data in this state object should be referencing the same plan.
 *
 * - `planDetails` is the base object for upsell plan data
 * - `upsellPlanBenefits` is derived from the planDetails object and stored
 *   separately for easy access in the UI
 */
export const INITIAL_STATE = {
  planDetails: {},
  upsellPlanBenefits: {},
};

export function orderPageReducer(state, action) {
  switch (action.type) {
    case SET_PLAN_DETAILS: {
      return {
        ...state,
        planDetails: action.payload.planDetails,
      };
    }
    case SET_UPSELL_PLAN_BENEFITS: {
      return {
        ...state,
        upsellPlanBenefits: action.payload.upsellPlanBenefits,
      };
    }
    default:
      return state;
  }
}
